import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateEmpresa,
  IGetEmpresa,
  IGetEmpresaOrdemServicoPaginatedParams,
  IGetEmpresaOrdemServicoPaginatedResponse,
  IIsFtrd
} from './empresa.model';
import {
  IGetFrotaEmpresaResponse,
  IOwnerEmpresaHistItem,
  ITransferirProprietarioEmpresaRequest,
  ITransferirProprietarioEmpresaResult
} from './transferencia-empresa.model';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  private http = inject(HttpClient);

  CreateEmpresa(body: ICreateEmpresa): Observable<any> {
    return this.http.post<any>(
      `${environment.baseURL}Empresa/CreateEmpresa`,
      body
    );
  }

  UpdateEmpresa(id: number, body: ICreateEmpresa): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}Empresa/UpdateEmpresa?id=${id}`,
      body
    );
  }

  GetEmpresaById(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.baseURL}Empresa/GetEmpresaById?id=${id}`
    );
  }

    GetEmpresaByFilter(
      nomeEmpresa?: string,
      pageNumber?: number,
      pageSize: number = 20,
      isFtrd: IIsFtrd = 0
    ): Observable<IGetEmpresa> {
      const url = `${environment.baseURL}Empresa/GetEmpresas`;
      const params: any = {};

      if (nomeEmpresa !== undefined) params.NM_FNTS_EPSA = nomeEmpresa;
      if (pageNumber !== undefined) params.PAGE_NUMBER = pageNumber;
      if (pageSize !== undefined) params.PAGE_SIZE = pageSize;
      if (isFtrd !== undefined && isFtrd !== 0) params.IS_FTRD = isFtrd;

      return this.http.get<IGetEmpresa>(url, { params });
    }

  PatchEmpresa(id: number, status: number) {
    const url = `${environment.baseURL}Empresa/PatchEmpresaIsFaturada?id=${id}`;

    const body = {
      FL_FTRD_EPSA: status
    };

    return this.http.patch<any>(url, body);
  }

  public patchEmpresaRestSenha(
    token: string | null,
    senha: string
  ): Observable<any> {
    const body = {
      ResetToken: token,
      TX_SENH_EPSA: senha
    };
    return this.http.patch<any>(
      `${environment.baseURL}Empresa/PacthEmpresaResetSenha`,
      body
    );
  }

  public GetEmpresaOrdemServicoPaginated(
    params: IGetEmpresaOrdemServicoPaginatedParams
  ): Observable<IGetEmpresaOrdemServicoPaginatedResponse> {
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;

    const invalidParams = ['', null, undefined, NaN, 0];

    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    return this.http.get<any>(
      `${environment.baseURL}Empresa/GetEmpresaOrdemServicoPaginated`,
      { params: validParams }
    );
  }

  GetFrotaEmpresa(params: {
    fkEpsa?: number;
    flAvulso?: boolean;
    fkMtrtExtr?: number;
  }): Observable<IGetFrotaEmpresaResponse> {
    const query: Record<string, string | number | boolean> = {};
    if (params.fkEpsa) query['fkEpsa'] = params.fkEpsa;
    if (params.flAvulso) query['flAvulso'] = true;
    if (params.fkMtrtExtr) query['fkMtrtExtr'] = params.fkMtrtExtr;

    return this.http.get<IGetFrotaEmpresaResponse>(
      `${environment.baseURL}Empresa/GetFrotaEmpresa`,
      { params: query }
    );
  }

  GetOwnerEmpresaHist(
    nuTipoEntd: number,
    fkEntd: number
  ): Observable<IOwnerEmpresaHistItem[]> {
    return this.http.get<IOwnerEmpresaHistItem[]>(
      `${environment.baseURL}Empresa/GetOwnerEmpresaHist`,
      { params: { nuTipoEntd, fkEntd } }
    );
  }

  TransferirProprietarioEmpresa(
    body: ITransferirProprietarioEmpresaRequest
  ): Observable<ITransferirProprietarioEmpresaResult> {
    return this.http.post<ITransferirProprietarioEmpresaResult>(
      `${environment.baseURL}Empresa/TransferirProprietarioEmpresa`,
      body
    );
  }
}
